import { get, post, put, del } from 'utils/methods';

export function getMachinesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}machines`, data, headers);
}

export function addNewMachineApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/machine`, data, headers);
}

export function editMachineApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/machine`, data, headers);
}

export function deleteMachineApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/machine`, data, headers);
}
